import EpisteckLanding from './pages/EpisteckLanding';

export default function App() {
  return <EpisteckLanding />;
}
